import HoverButton from "../hoverButton";
import { useNavigate } from "react-router-dom";
const Experience = () => {
  const navigate = useNavigate();
  return (
    <div className="px-3 sm:px-6 lg:px-5 xl:px-10">
      <div className="bg-[#111111] flex justify-center items-center xs:flex-col lg:h-80 xs:px-5 xs:py-4 sm:p-5 lg:px-20 rounded-3xl xs:my-8 sm:mt-10 sm:mb-12 lg:mt-10 lg:mb-16">
        <div className="lg:w-4/5 xs:w-full sm:w-2/3">
          <h2 className="capitalize xl:w-3/4 sm:w-72 sm:mb-1 text-secondary font-unboundedBold lg:text-4xl sm:text-lg lg:leading-tight xs:pb-2">
            Have questions or want to collaborate?
            <span className="bg-orangeCrayola rounded-full ml-1 lg:px-2 xs:px-1 sm:px-1">
              GEM
            </span>
          </h2>
          <p className="text-secondary font-onestLight lg:text-sm lg:w-4/5 lg:pt-5 xs:leading-4 xs:text-sm sm:text-sm sm:leading-4">
            We’d love to hear from you. Whether you’re a creative, brand,
            investor, or fan, reach out and let’s build something great
            together.
          </p>
        </div>
        <div className="xs:justify-center xs:items-center xs:pt-3 lg:w-2/6 sm:w-5/12 flex justify-end ">
          <HoverButton
            extraClasses={
              "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
            }
            BtnTitle={"Lets Get in Touch"}
            disabled={false}
            onClick={() => navigate("/contact-us")}
            BtnTitleClasses={
              "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
            }
          />
        </div>
      </div>
    </div>
  );
};
export default Experience;
